import { Link } from 'react-router-dom';
import { t } from 'i18next';
import SmallArrowRightIcon from '../my-page-test-icon/SmallArrowRightIcon';

const MyPageMenuItem = ({
  item,
  isLastItem,
  onClick
}: {
  item: { title: string; path: string; onClick?: () => void };
  isLastItem: boolean;
  onClick?: () => void;
}) => {
  const itemClasses = `py-[14px] pl-[4px] ${
    !isLastItem
      ? 'shadow-[inset_0_-1px_0_0_rgba(0,0,0,0.04)] dark:shadow-[inset_0_-1px_0_0_rgba(255,255,255,0.06)]'
      : ''
  }`;

  return (
    <div className={itemClasses}>
      {onClick ? (
        <button
          type="button"
          onClick={onClick}
          className="text-main-light-3 dark:text-main-dark-3 text-[13px] flex items-center justify-between font-medium w-full"
        >
          {t(item.title)}
          <SmallArrowRightIcon className="fill-main-light-4 dark:fill-main-dark-4 w-[16px] h-[16px]" />
        </button>
      ) : (
        <Link
          to={item.path}
          className="text-main-light-3 dark:text-main-dark-3 text-[13px] flex items-center justify-between font-medium"
        >
          {t(item.title)}
          <SmallArrowRightIcon className="fill-main-light-4 dark:fill-main-dark-4 w-[16px] h-[16px]" />
        </Link>
      )}
    </div>
  );
}

export default MyPageMenuItem